export default [
  {
    name: "HG",
    id: "07f88233-1f48-4781-8d89-2669a80e393d",
  },
  {
    name: "KK - stora salen",
    id: "c510648d-37a0-4019-87e1-fbbf1b1adf3a",
  },
  {
    name: "KK - lilla salen",
    id: "d1d12a5b-8bcb-47b2-9450-e0d490aa6a96",
  },
  {
    name: "KK - minsta salen",
    id: "793633a6-bb8b-4646-b9fb-3a303ea1bbda",
  },
  {
    name: "KK - forumteatern",
    id: "b452eaa3-b28c-41ee-ac04-13c1eb348f34",
  },
  {
    name: "KK",
    id: "a232bbef-b3c3-4e0b-9736-3775139578d9",
  },
  {
    name: "Kårallen - matsalen",
    id: "fa5bc487-5753-48da-beb7-bf6b31b9f94a",
  },
  {
    name: "Kårallen - gasquen",
    id: "a2f3bf6e-f7a1-4e7a-8c8f-9119a147f558",
  },
  {
    name: "Kårallen - baljan",
    id: "50923589-f79b-4770-ac8b-35fee2a497f2",
  },
  {
    name: "Kårallen - slagsidan",
    id: "6761befd-c037-4437-bbf2-71d7807bc758",
  },
  {
    name: "Kårallen - luftrummet",
    id: "c7c5b4ac-3534-41d7-8090-b39986fbdeea",
  },
  {
    name: "Kårallen - skrivsalen",
    id: "87668379-c5c9-4171-b9aa-bd41761d8685",
  },
  {
    name: "Kårallen - innergården",
    id: "806aa762-4e68-49f7-9258-46e6e047f6d8",
  },
  {
    name: "Kårallen",
    id: "ed559a94-faaf-4daf-b70f-c7439fb989d7",
  },
  {
    name: "Amfi",
    id: "bc15ae77-59f4-4531-9790-6040f264bb87",
  },
  {
    name: "Blå havet",
    id: "5c7326f1-b3a9-4e62-9a25-923a97cb181f",
  },
  {
    name: "Örat",
    id: "bded005f-8e83-4fdf-8b1b-0d2084391af6",
  },
]; /* .map(({ name, id }) => ({
  name,
  id,
  locationId: locations.others.Kårhus.id
})) */
